module.exports = "/_next/static/images/96104b74bf42209bb8bc3baee9a150eb-mulher-com-cachos-maravilhosos-segurando-cartao-lg@1x.jpg";